import React from "react";
import Dialog, { DialogProps } from "components/Dialog";
import { Text } from "@ui-kitten/components";
import Spacer from "components/Spacer";
import { RecipientInfo } from "./MyGifts";
import { View } from "react-native";
import * as yup from "yup";
import { Field, Formik } from "formik";
import TextInput from "components/TextInput";
import Button from "components/Button";
import DatePickerInput from "components/DatePicker/DatePicker";
import dayjs from "dayjs";

interface Props extends DialogProps {
  originalRecipientInfo: RecipientInfo;
  onSubmit: (recipientInfo: RecipientInfo) => void;
  loading: boolean;
}

const validationSchema = yup.object({
  firstName: yup.string().required().label("Recipient first name"),
  lastName: yup.string().required().label("Recipient last name"),
  email: yup.string().email().required().label("Recipient email"),
  deliverAt: yup.date().required().label("Deliver at"),
});
const UpdateRecipientDialog = (props: Props) => {
  const {
    originalRecipientInfo,
    onSubmit,
    loading,
    setVisible,
    visible,
    ...otherProps
  } = props;

  const tomorrow = dayjs().add(1, "day").toDate();

  return (
    <Dialog visible={visible} {...otherProps}>
      <Text category="h6">Update Recipient Info</Text>
      <Spacer />
      <Formik
        initialValues={originalRecipientInfo}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
      >
        {({ isValid, handleSubmit }) => {
          return (
            <View>
              <View className="space-y-4">
                <Field
                  label="Recipient First Name"
                  name="firstName"
                  component={TextInput}
                />
                <Field
                  label="Recipient Last Name"
                  name="lastName"
                  component={TextInput}
                />
                <Field
                  label="Recipient Email"
                  name="email"
                  component={TextInput}
                />
                <Field
                  label="Delivery Date"
                  name="deliverAt"
                  component={DatePickerInput}
                  min={tomorrow}
                />
              </View>
              <View className=" justify-end flex-row space-x-2">
                <Button
                  appearance="ghost"
                  onPress={() => setVisible && setVisible(false)}
                >
                  Close
                </Button>
                <Button
                  appearance="ghost"
                  loading={loading}
                  disabled={!isValid}
                  onPress={() => handleSubmit()}
                >
                  Update Recipient Info
                </Button>
              </View>
            </View>
          );
        }}
      </Formik>
    </Dialog>
  );
};

export default UpdateRecipientDialog;
